import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AuthorizedRoute from './common/AuthorizedRoute';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Registration from './components/Registration';
import ResetPassword from './components/ResetPassword';
import withServices from './hocs/withServices';

function App({ services }) {

  return (
    // <EducationInfo></EducationInfo>
    <Switch>
      <Route path="/login" component={Login}>
        {services.auth.isLoggedIn() && <Redirect to="/" />}
      </Route>
      <Route path="/registration" component={Registration}>
        {services.auth.isLoggedIn() && <Redirect to="/" />}
      </Route>
      <Route path="/reset-password" component={ResetPassword}>
        {services.auth.isLoggedIn() && <Redirect to="/" />}
      </Route>
      <AuthorizedRoute path="/" component={Dashboard} />
    </Switch>
  );
}

export default withServices()(App);
